/** @format */

import { Box } from '@mui/material';
import AiPrompt from './promptbox/AiPrompt';
import { useState } from 'react';

function AskAi() {
  const [prompt, setPrompt] = useState('');

  function handlePrompt(val) {
    setPrompt(val.trim());
  }

  return (
    <Box>
      <AiPrompt prompt={prompt} handlePrompt={handlePrompt} />
    </Box>
  );
}

export default AskAi;
